import {
  addDays,
  format,
  isSameDay,
  isSameMonth,
  isWithinInterval,
  startOfDay,
  toDate,
} from 'date-fns';
import styles from '../../styles/calendar/Calendar.module.scss';

const CalendarCell = ({
  day,
  monthStart,
  onDateClick,
  calendarData,
  renderCellContent,
  selectedDate,
  setSelectedDate,
}) => {
  const dateFormat = 'd';
  const formattedDate = format(day, dateFormat);
  const dataForDay = calendarData?.[formattedDate] || [];
  const upcomingFlag = isWithinInterval(day, {
    start: startOfDay(new Date()),
    end: addDays(new Date(), 7),
  });
  const cellClassName = !isSameMonth(day, monthStart)
    ? styles['colCellDisabled']
    : isSameDay(day, selectedDate)
    ? styles['colCellSelected']
    : styles['colCell'];
  return (
    <div
      key={day.toString()}
      style={dataForDay.length > 0 ? { cursor: 'pointer' } : {}}
      className={cellClassName}
      onClick={() => {
        setSelectedDate(toDate(day));
        onDateClick(toDate(day), dataForDay);
      }}>
      <span className={styles['cellNumber']}>{formattedDate}</span>
      <span className={styles['bg']}>{formattedDate}</span>

      {isSameMonth(day, monthStart) &&
        dataForDay.length > 0 &&
        renderCellContent(dataForDay, upcomingFlag, formattedDate)}
    </div>
  );
};

export default CalendarCell;
